// Mock data for Pawsome Ventures website
// Note: Only pricing and stats remain here
// All other data (services, testimonials, FAQs, how-it-works, partners) is now in MongoDB

export const pricingCategories = [
  {
    id: 1,
    category: "Consultation & Documentation",
    services: [
      {
        name: "Travel Consultation",
        description: "Initial consultation to discuss your pet's travel needs and requirements",
        pricing: {
          base: "$50 for up to 30 minutes",
          additional: "$80 per hour thereafter"
        },
        includes: []
      },
      {
        name: "In-Home Health Certificates",
        description: "Veterinary examination and health certificate preparation in your pet's home",
        pricing: {
          base: "Priced specific to destination country and administrative documentation work",
          homeVisit: "Home visit priced specific to location on island"
        },
        includes: [
          "In-home veterinary examination",
          "Routine vaccinations as needed",
          "Deworming treatments for travel",
          "Health certificate preparation",
          "Destination-specific compliance"
        ]
      },
      {
        name: "Cayman Islands Import Permit & Compliance Service",
        description: "Complete import permit processing and documentation",
        bundleNote: "Bundle available — pair with Cayman Dog Licensing for $390 (save $35)",
        pricing: {
          firstPet: "$350",
          firstAdditional: "$300",
          secondAdditional: "$250"
        },
        includes: [
          "Application management with DOA",
          "Bespoke guidance and direct communication with breeders, veterinary clinics, and other third party stakeholders",
          "Health certificate template preparation",
          "$50 DOA import application fee per pet"
        ]
      },
      {
        name: "Export Permit Services",
        description: "For destinations like NZ, Australia, South Africa",
        pricing: {
          firstPet: "$500",
          firstAdditional: "$450",
          secondAdditional: "$400"
        },
        includes: [
          "Relevant research and timeline creation",
          "Application/document management",
          "Coordination of blood tests and treatments",
          "Payment and collection of signed permits",
          "$20 DOA export application fee per permit"
        ]
      },
      {
        name: "Export Permit Endorsement Coordination and Document Collection",
        description: "Appointment coordination, documentation review, payment, and collection of signed export documents",
        note: "Price will increase accordingly if multiple export permits are needed based on the travel itinerary",
        pricing: {
          firstPet: "$85",
          firstAdditional: "$65",
          secondAdditional: "$45"
        },
        includes: [
          "Review of documentation for accuracy and completeness",
          "Payment and collection from DOA",
          "$20 DOA export application fee per permit"
        ]
      },
      {
        name: "Pet Passport Application",
        description: "Complete pet passport application and processing",
        pricing: {
          base: "$250 per pet"
        },
        includes: [
          "Procurement of all required documentation (rabies certificate, microchip records, prior passport, vet records)",
          "Application submission to the DOA on your behalf",
          "Collection of the issued pet passport from DOA",
          "Digital scan of the finalised passport emailed to you for safekeeping",
          "$150 DOA pet passport application fee"
        ]
      },
      {
        name: "IATA Crate/Carrier Compliance Guidance Service",
        description: "Expert sizing and compliance guidance so your pet's crate or carrier clears airline check-in first time",
        bundleNote: "Bundle available — pair with In-Home Pet Sizing & Measurement for $100 (save $25)",
        pricing: {
          base: "$50 per pet"
        },
        includes: [
          "IATA CR82 compliance review — verifying crate/carrier meets live-animal transport standards including dimensions and ventilation",
          "Sizing consultation — tailored recommendations based on your pet's measurements and build for smooth airline check-in",
          "Purchase or hire guidance — vetted supplier list with links to compliant crates/carriers",
          "Pre-flight inspection — final visual/photo check before travel day to avoid surprises"
        ]
      },
      {
        name: "In-Home Pet Sizing & Measurement Service",
        description: "In-home visit to take precise measurements of your pet so you can confidently order the right crate/carrier",
        bundleNote: "Bundle available — pair with IATA Crate/Carrier Compliance Guidance for $100 (save $25)",
        pricing: {
          base: "$75 per pet"
        },
        includes: [
          "In-home visit at a time that suits you and your pet",
          "Precise measurements taken by hand",
          "Written record for future reference"
        ]
      },
      {
        name: "Pet Sizing & IATA Crate/Carrier Compliance Bundle",
        description: "In-home measurement + full IATA crate/carrier compliance guidance in one seamless service",
        note: "Save $25 vs booking separately — standalone rates are $75 (In-Home Sizing) + $50 (IATA Guidance) = $125",
        pricing: {
          base: "$100 per pet"
        },
        includes: [
          "In-home visit at a time that suits you and your pet",
          "Precise measurements taken by hand",
          "Written record for future reference",
          "IATA CR82 compliance review — verifying crate/carrier meets live-animal transport standards including dimensions and ventilation",
          "Sizing consultation — tailored recommendations based on your pet's measurements and build for smooth airline check-in",
          "Purchase or hire guidance — vetted supplier list with links to compliant crates/carriers",
          "Pre-flight inspection — final visual/photo check before travel day to avoid surprises"
        ]
      },
      {
        name: "Cayman Dog Licensing Convenience Service",
        description: "One-off convenience service — we handle the DOA visit, collect your dog's licence tag, and deliver it to you",
        bundleNote: "Bundle available — pair with Cayman Islands Import Permit for $390 (save $35 per pet)",
        pricing: {
          base: "$75 per dog"
        },
        includes: [
          "Dog licence application submitted with DOA on your behalf",
          "Collection of your dog's licence tag from DOA",
          "Delivery of the tag to your home address in Grand Cayman",
          "One-off service — Cayman dog licences do not require renewal"
        ]
      },
      {
        name: "Cayman Islands Import Permit + Dog Licence Bundle",
        description: "Full import permit workflow + dog licence handled end-to-end — the fastest arrival experience for new expat dog owners",
        note: "Save $35 per pet vs booking separately",
        pricing: {
          firstPet: "$390",
          firstAdditional: "$340",
          secondAdditional: "$290"
        },
        includes: [
          "Application management with DOA",
          "Bespoke guidance and direct communication with breeders, veterinary clinics, and other third party stakeholders",
          "Health certificate template preparation",
          "$50 DOA import application fee per pet",
          "Dog licence application submitted with DOA on your behalf",
          "Collection of your dog's licence tag from DOA",
          "Delivery of the tag to your home address in Grand Cayman",
          "One-off — Cayman dog licences do not require renewal"
        ]
      },
      {
        name: "Document Delivery Service",
        description: "Hand-delivery of Pawsome Ventures documents to your home or office on Grand Cayman",
        note: "Quote provided once delivery destination and timing are confirmed",
        pricing: {
          base: "Bespoke Quotation"
        },
        includes: [
          "Hand-delivery of any Pawsome Ventures documents (permits, health certificates, passports) to your home or office",
          "Pricing based on destination district (George Town, Seven Mile, West Bay, Bodden Town, East End, North Side)"
        ]
      }
    ]
  },
  {
    id: 2,
    category: "Travel & Logistics",
    services: [
      {
        name: "Export Cargo Services",
        description: "Complete cargo coordination services, crate preparation assistance, pre-departure pet companionship, and travel updates",
        pricing: {
          base: "$250"
        },
        includes: [
          "Delivery of export paperwork to cargo agent",
          "Signing of cargo documents",
          "Observation and assistance with crate preparations",
          "Assistance with DOA pet verification and crate sealing procedures",
          "Keeping pet(s) company prior to check-in procedures",
          "Provision of pet photos and videos to owners"
        ],
        note: "Pet collection/transportation is additional"
      },
      {
        name: "Flight Arrangements and Airline Coordination Service",
        description: "Airline research, booking, and travel-day coordination",
        pricing: {
          firstPet: "$175",
          additional: "$85 each additional"
        },
        includes: [
          "Coordination directly with airlines",
          "Securing pet's travel booking",
          "Air and/or ground transfer coordination"
        ]
      },
      {
        name: "International Broker Coordination Service",
        description: "Liaison with overseas brokers for accompanied or unaccompanied travel",
        pricing: {
          firstPet: "$175",
          additional: "$85 each additional"
        },
        includes: [
          "Coordination with international brokers",
          "Customs clearance compliance",
          "End-to-end broker liaison from Cayman to destination"
        ]
      },
      {
        name: "Brokerage Travel Services",
        description: "For medical pet travel or broker-accompanied journeys",
        pricing: {
          base: "Bespoke Quotation"
        },
        includes: [],
        note: "All flights, accommodation, and per diems paid at client's expense"
      },
      {
        name: "Cargo & Customs Pet Pre-Clearance",
        description: "Pre-clearance services through cargo and customs",
        pricing: {
          firstPet: "$300",
          firstAdditional: "$250",
          secondAdditional: "$200"
        },
        includes: [
          "Procurement of all required customs pre-clearance documents",
          "Pre-clearance through cargo and customs",
          "All relevant clearance fees included"
        ]
      },
      {
        name: "Transportation Coordination Service",
        description: "Pet ground transport quoted based on number of pets, kennel weight, and pickup/drop-off location",
        pricing: {
          base: "Bespoke Quotation"
        },
        includes: [
          "Door-to-airport (or airport-to-door) transport within Grand Cayman",
          "Coordinated pickup and drop-off scheduling",
          "Vehicle sized to your pet's kennel dimensions and weight",
          "Multi-pet trip coordination"
        ],
        note: "Quote provided once pet count, kennel weight, and pickup location are confirmed"
      },
      {
        name: "Custom Crate Builder Coordination Service",
        description: "Introduction and end-to-end coordination with a vetted custom crate builder for oversized or bespoke IATA-compliant crates",
        pricing: {
          base: "$75"
        },
        includes: [
          "Introduction to a vetted local custom crate builder",
          "Handover of pet specifications and IATA CR82 compliance requirements",
          "Timeline coordination with the builder's lead-times",
          "Pickup or delivery coordination once the crate is built"
        ],
        note: "Crate builder's own fee is quoted directly by the builder and paid separately"
      }
    ]
  },
  {
    id: 3,
    category: "Health & Compliance",
    services: [
      {
        name: "CDC Dog Import Application",
        description: "Mandatory CDC import permit for USA entry (effective August 1, 2024)",
        pricing: {
          base: "$50 per dog"
        },
        includes: ["Online application for mandatory CDC import permit"]
      },
      {
        name: "Annual Document Maintenance",
        description: "Year-round document tracking and reminders",
        pricing: {
          firstPet: "$100",
          firstAdditional: "$75",
          secondAdditional: "$50"
        },
        includes: [
          "Reminders for rabies vaccinations",
          "Rabies titre testing reminders",
          "Pet passport renewal reminders",
          "Rabies vaccination scheduling with DOA"
        ]
      },
      {
        name: "Rabies Vaccination Appointment Scheduling",
        description: "Appointment booking with Department of Agriculture",
        pricing: {
          base: "$25 per pet"
        },
        includes: [
          "Information sheet completion and submission",
          "Appointment confirmation",
          "Provision of appointment details"
        ]
      },
      {
        name: "Rabies Vaccination Appointment Service",
        description: "Complete vaccination appointment management and transportation",
        pricing: {
          firstPet: "$100",
          additional: "$75 each additional"
        },
        includes: [
          "Transportation to DOA",
          "Appointment scheduling",
          "Pet pickup and drop-off",
          "$25 DOA fee",
          "Vaccination certificate management"
        ]
      },
      {
        name: "Microchip Implantation Service",
        description: "Add-on to Rabies Vaccination Appointment Service",
        pricing: {
          firstPet: "$80",
          additional: "$65 each additional"
        },
        includes: [
          "$50 DOA fee",
          "All benefits of Rabies Vaccination Service"
        ]
      }
    ]
  }
];

export const stats = [
  { number: "5000+", label: "Pets Relocated" },
  { number: "75+", label: "Countries Served" },
  { number: "99.8%", label: "Success Rate" },
  { number: "24/7", label: "Support Available" }
];
